<template>
	<!-- 관리자 공통 셸 — 사내 디자인 시스템 SideNavShell + GlobalHeader 와 같은 조립(좌측 메뉴 248/64 · 상단 바 48 · 본문 16, 최대폭 1680).
	     셸 · 좌측 메뉴 · 상단 바는 여기 한 번만 두고, 화면은 본문(router-view)만 그린다. -->
	<div class="admin-shell" :class="{ 'observability-admin-layout': isObservability }">
		<admin-sidebar :collapsed="navCollapsed"/>
		<div class="admin-shell-body">
			<admin-global-header :nav-collapsed="navCollapsed" @toggle-nav="toggleNav"/>
			<!-- 화면 제목 자리(DS #pageHeader) — 내용은 화면의 <admin-page-header> 가 정한다 -->
			<admin-page-header-view v-if="pageHeader" :header="pageHeader.header"/>
			<main class="admin-shell-main">
				<router-view/>
			</main>
		</div>
	</div>
</template>

<script>
import AdminSidebar from '@shared_components/admin/components/common/sidebar'
import AdminGlobalHeader from '@shared_components/admin/components/common/AdminGlobalHeader'
import AdminPageHeaderView from '@shared_components/admin/components/common/AdminPageHeaderView.vue'

// DS useNav 와 같은 저장 키·값('1' 접힘 / '0' 펼침) — Vue 3 화면과 접힘 상태를 같이 쓴다.
// 저장값이 없으면 폭 1280 미만에서 접힌 채 시작한다(DS 와 같은 기준).
const NAV_KEY = 'ds-nav-collapsed'

function initialCollapsed () {
	try {
		const saved = localStorage.getItem(NAV_KEY)
		if (saved === '1' || saved === '0') return saved === '1'
	} catch (e) { /* 저장소를 못 쓰면 폭으로 정한다 */ }
	return window.innerWidth < 1280
}

export default {
	name: 'LayoutAdmin',
	components: {
		AdminSidebar,
		AdminGlobalHeader,
		AdminPageHeaderView,
	},
	provide () {
		// 화면의 <admin-page-header> 가 제목 내용을 등록한다. 화면이 바뀌는 순간 새 화면이 먼저 생기고
		// 옛 화면이 나중에 사라지므로, 지울 때는 «지금 주인»일 때만 지운다
		return {
			adminShell: {
				setPageHeader: (owner, header) => { this.pageHeader = {owner, header} },
				clearPageHeader: owner => { if (this.pageHeader && this.pageHeader.owner === owner) this.pageHeader = null },
			},
		}
	},
	data () {
		return {
			navCollapsed: initialCollapsed(),
			pageHeader: null,
		}
	},
	computed: {
		isObservability () {
			return this.$route.name === 'ApiObservability'
		},
	},
	methods: {
		toggleNav () {
			this.navCollapsed = !this.navCollapsed
			try {
				localStorage.setItem(NAV_KEY, this.navCollapsed ? '1' : '0')
			} catch (e) { /* 저장 못 해도 이번 화면에서는 접힌다 */ }
		},
	},
}
</script>

<style lang="scss">
.admin-shell {
	// 본문 안에서 위에 붙는(sticky) 요소가 상단 바 아래에 서도록 높이를 알려 준다
	--ds-shell-header-h: 48px;
	display: flex;
	align-items: flex-start;
	min-height: 100vh;
	background-color: var(--ds-background);
}

.admin-shell-body {
	display: flex;
	flex: 1;
	flex-direction: column;
	min-width: 0;
	min-height: 100vh;
}

.admin-shell-main {
	flex: 1;
	width: 100%;
	max-width: 1680px;
	margin: 0 auto;
	padding: 16px;
}

// 화면의 바깥 b-container fluid 좌우 여백(15)을 빼서 본문 내용이 제목 영역 · 상단 바와 같은 세로선(16)에 서게 한다
.admin-shell-main > .container-fluid {
	padding-left: 0;
	padding-right: 0;
}

// 화면 높이를 채우는 목록(평가관리 · 프로젝트 코드 · 원청사) — 상단 바 48 과 본문 위아래 16 을 뺀다
.admin-body-full-height {
	max-height: calc(100vh - 48px - 2rem);
	height: calc(100vh - 48px - 2rem);
}

// API 이용 현황은 자체 판을 꽉 채워 그린다
.observability-admin-layout .admin-shell-main {
	max-width: none;
	padding: 0;
}
</style>
